import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { PageLayout } from '@/shared/components/PageLayout';
import { Drawer } from '@/shared/components/Drawer';
import { FormAddingUser } from './components/FormAddingUser';
import { rowsPerPageSetting, UsersTable } from './components/UsersTable';
import { useGetUsers } from './services/hooks/use-get-users';
const DEFAULT_PAGE_SIZE = 50;
const PAGE_NUMBER_PARAM = 'pageNumber';
const PAGE_SIZE_PARAM = 'pageSize';
// Пагинация хранится в query-параметрах, чтобы после F5 открывалась та же страница.
// Невалидные значения из адресной строки заменяются значениями по умолчанию.
const parsePagination = (search) => {
    const params = new URLSearchParams(search);
    const pageNumber = Number(params.get(PAGE_NUMBER_PARAM));
    const pageSize = Number(params.get(PAGE_SIZE_PARAM));
    return {
        pageNumber: Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : 1,
        pageSize: rowsPerPageSetting.includes(pageSize) ? pageSize : DEFAULT_PAGE_SIZE,
    };
};
export const Users = () => {
    const history = useHistory();
    const { search } = useLocation();
    const { pageNumber, pageSize } = parsePagination(search);
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const [isOpenUserDrawer, setIsOpenUserDrawer] = useState(false);
    const [targetUser, setTargetUser] = useState();
    const [filters, setFilters] = useState({});
    const { data: usersList } = useGetUsers({ pageSize, pageNumber, ...filters });
    const setPagination = (nextPageNumber, nextPageSize, replace = false) => {
        const params = new URLSearchParams(history.location.search);
        params.set(PAGE_NUMBER_PARAM, String(nextPageNumber));
        params.set(PAGE_SIZE_PARAM, String(nextPageSize));
        const location = { search: `?${params.toString()}` };
        if (replace) {
            history.replace(location);
        }
        else {
            history.push(location);
        }
    };
    const totalPages = usersList?.totalPages ?? 0;
    // После удаления строк, смены фильтра или ручной правки URL страница может оказаться за пределами списка.
    useEffect(() => {
        if (totalPages > 0 && pageNumber > totalPages) {
            setPagination(totalPages, pageSize, true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalPages, pageNumber, pageSize]);
    const handleAddProfile = () => {
        setIsOpenDrawer(true);
    };
    const handleClickRowByUsersTable = (data) => {
        setTargetUser(data);
        setIsOpenUserDrawer(true);
    };
    const handleChangePage = (page) => {
        setPagination(page, pageSize);
    };
    const handleChangeRowsPerPage = (size) => {
        setPagination(1, size);
    };
    const handleChangeFilter = (id, value) => {
        setFilters((prev) => {
            const next = { ...prev };
            if (value) {
                next[id] = value;
            }
            else {
                delete next[id];
            }
            return next;
        });
        // Отфильтрованных строк может быть меньше - иначе останемся на несуществующей странице.
        // replace - смена фильтра не должна добавлять запись в историю браузера.
        setPagination(1, pageSize, true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PageLayout, null,
            React.createElement(Box, { height: "75vh" },
                React.createElement(Box, { mb: 1 },
                    React.createElement(Typography, { variant: "h4" }, "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438")),
                React.createElement(Box, { mb: 2 },
                    React.createElement(Button, { variant: "contained", color: "primary", startIcon: React.createElement(AddCircleIcon, null), onClick: handleAddProfile }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C")),
                React.createElement(UsersTable, { rows: usersList?.users ?? [], onClickRow: handleClickRowByUsersTable, totalCount: usersList?.totalCount ?? 0, totalPages: totalPages, pageSize: pageSize, currentPage: pageNumber, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, possibleFilters: usersList?.possibleFilters, filters: filters, onChangeFilter: handleChangeFilter }))),
        React.createElement(Drawer, { isOpen: isOpenDrawer, onClose: () => setIsOpenDrawer(false) },
            React.createElement(FormAddingUser, { onSubmit: () => setIsOpenDrawer(false) })),
        React.createElement(Drawer, { isOpen: isOpenUserDrawer, onClose: () => setIsOpenUserDrawer(false) },
            React.createElement(FormAddingUser, { key: targetUser?.guid, isEditing: true, initialState: targetUser, onSubmit: () => setIsOpenUserDrawer(false) }))));
};
